package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

internal object MakafJoiner {

    /**
     * Joins tokens while keeping Makaf behavior:
     * - If a word ends with MAKAF, do not add a space after it.
     * - Otherwise, separate by single spaces.
     */
    fun joinWordsKeepingMakaf(
        words: List<String>,
        makaf: Char,
    ): String {
        if (words.isEmpty()) return ""

        val sb = StringBuilder()
        words.forEachIndexed { index, w ->
            sb.append(w)

            val isLast = index == words.lastIndex
            val endsWithMakaf = w.endsWith(makaf.toString())

            if (!isLast && !endsWithMakaf) {
                sb.append(" ")
            }
        }
        return sb.toString()
    }
}
